type Props = {
  size?: number;
};

export default function CriteriaEmptyIcon({ size = 40 }: Props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} fill='none' viewBox='0 0 40 40'>
      <path
        stroke='#7c39ed'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M30.885 13.27a4.948 4.948 0 1 0 0-9.895 4.948 4.948 0 0 0 0 9.896M34.385 11.82l3.428 3.43M21.188 12.875H4.563A2.375 2.375 0 0 1 2.188 10.5V8.125A2.375 2.375 0 0 1 4.563 5.75h16.625M10.5 20h19M10.5 28.313h19M10.5 36.625h19'
      />
      <path
        stroke='#7c39ed'
        strokeWidth='2'
        d='M5.156 20a.594.594 0 1 1 0-1.187M5.156 20a.594.594 0 1 0 0-1.187M5.156 28.313a.594.594 0 1 1 0-1.188M5.156 28.313a.594.594 0 1 0 0-1.188M5.156 36.625a.594.594 0 1 1 0-1.187M5.156 36.625a.594.594 0 1 0 0-1.187'
      />
    </svg>
  );
}
